export const ADD_TO_QUEUE = 'ADD_TO_QUEUE';
export const ADD_TO_QUEUE_AND_SET_CURRENT = 'ADD_TO_QUEUE_AND_SET_CURRENT';
export const REMOVE_FROM_QUEUE = 'REMOVE_FROM_QUEUE';
export const RESET_QUEUE = 'RESET_QUEUE';
export const CHANGE_QUEUE_STATUS = 'CHANGE_QUEUE_STATUS';
export const SHUFFLE_QUEUE = 'SHUFFLE_QUEUE';
export const ADD_TO_QUEUE_ERROR = 'ADD_TO_QUEUE_ERROR';



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/queue/state/types.js